module.exports = __webpack_public_path__ + "assets/Media.19be7a49.svg";